export * from './countdown-component-config.interface';
